import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer flex items-center text-xs px-8 justify-start">
      2026 GSPEN © All rights reserved
    </div>
  );
};

export default Footer;
